import { useState } from "react"
import { FormatDateString } from "../../utils/FormatDate";
import NoDataScreen from "../ui/temp-screens/NoDataScreen";
import DetailsButton from "../ui/components/DetailsButton"
import { Link } from "react-router-dom"
import { FaFile } from "react-icons/fa"

const ChecklistServicio = ({checklistCompleted, checklistCompletedDate, checklistMedia, checklistNotes}) => {

  const [media] = useState(checklistMedia ? checklistMedia : [])
  const [notes] = useState(checklistNotes ? checklistNotes : "")

  return (
    <div className="p-3 shadow border rounded text-xs">
      {/* Header */}
      <div className="flex flex-row justify-between items-center mb-2">
        <h3 className="text-xs font-bold text-slate-600">Checklist</h3>
        {checklistCompleted && checklistCompletedDate && (
          <span className={`text-[10px] font-bold text-slate-600`}>
            {FormatDateString(checklistCompletedDate)}
          </span>
        )}
      </div>

      {/* Notes */}
      <div className="flex flex-col gap-2 mb-2">
        <h3 className="text-xs font-bold text-slate-600">Notas</h3>
        <textarea 
          name="checklistNotes" 
          id="checklistNotes" 
          className="w-full h-24 text-[10px] border border-gray-200 rounded-md p-2" 
          value={notes} 
          disabled
          readOnly
        />
      </div>
      
      {/* Header media */}
      <div className="flex flex-row justify-between items-center mt-2 mb-2">
        <h3 className="text-xs font-bold text-slate-600">Media</h3>
      </div>

      {/* Media */}
      <div className="flex flex-col gap-2 border border-gray-200 bg-gray-50 p-2 shadow-md">
        {media.length > 0 ? (
          media.map((i) => (
            <div key={i.id} className="flex flex-row items-center justify-center gap-2 rounded-md">
              {i.mimeType?.startsWith('image/') ? (
                <div className="flex flex-col gap-2 items-center justify-center w-full p-2 bg-white rounded-md">
                  <div className="flex flex-row gap-2 items-center justify-between w-full ">
                    <span className="text-xs font-bold text-slate-600">{i.filename}</span>
                    <div className="flex flex-row gap-2 items-center justify-center">
                      <Link to={i.url} target="_blank" rel="noopener noreferrer">
                        <DetailsButton
                          content={"Abrir en nueva pestaña"}
                          type="externalLink"
                        />
                      </Link>
                    </div>
                  </div>
                  <img src={i.url} alt="media" className="h-36 rounded-md object-cover" />
                </div>
              ) : i.mimeType?.startsWith('audio/') ? (
                <div className="flex flex-col gap-2 items-center justify-center w-full p-2 bg-white rounded-md">
                  <div className="flex flex-row gap-2 items-center justify-between w-full ">
                    <span className="text-xs font-bold text-slate-600">{i.filename}</span>
                    <div className="flex flex-row gap-2 items-center justify-center">
                      <Link to={i.url} target="_blank" rel="noopener noreferrer">
                        <DetailsButton
                          content={"Abrir en nueva pestaña"}
                          type="externalLink"
                        />
                      </Link>
                    </div>
                  </div>
                  <audio src={i.url} controls className="w-full" />
                </div>
              ) : i.mimeType?.startsWith('application/pdf') ? (
                <div className="flex flex-col gap-2 items-center justify-center w-full p-2 bg-white rounded-md">
                  <div className="flex flex-row gap-2 items-center justify-between w-full ">
                    <span className="text-xs font-bold text-slate-600">{i.filename}</span>
                    <div className="flex flex-row gap-2 items-center justify-center">
                      <Link to={i.url} target="_blank" rel="noopener noreferrer">
                        <DetailsButton
                          content={"Abrir en nueva pestaña"}
                          type="externalLink"
                        />
                      </Link>
                    </div>
                  </div>
                  <iframe 
                    src={i.url} 
                    className="w-full h-36 rounded-md"
                    title="PDF Preview"
                  />                  
                </div>
              ) : i.mimeType?.startsWith('video/') ? (
                <div className="flex flex-col gap-2 items-center justify-center w-full p-2 bg-white rounded-md">
                  <div className="flex flex-row gap-2 items-center justify-between w-full ">
                    <span className="text-xs font-bold text-slate-600">{i.filename}</span>
                    <div className="flex flex-row gap-2 items-center justify-center">
                      <Link to={i.url} target="_blank" rel="noopener noreferrer">
                        <DetailsButton
                          content={"Abrir en nueva pestaña"}
                          type="externalLink"
                        />
                      </Link>
                    </div>
                  </div>
                  <video src={i.url} controls className="h-48 rounded-md" />
                </div>
              ) : (
                <div className="flex flex-col gap-2 items-center justify-center w-full p-2 bg-white rounded-md">
                  <div className="flex flex-row gap-2 items-center justify-between w-full ">
                    <span className="text-xs font-bold text-slate-600">{i.filename}</span>
                    <div className="flex flex-row gap-2 items-center justify-center">
                      <Link to={i.url} target="_blank" rel="noopener noreferrer">
                        <DetailsButton
                          content={"Abrir en nueva pestaña"}
                          type="externalLink"
                        />
                      </Link>
                    </div>
                  </div>
                  <div className="flex flex-row gap-2 items-center border border-gray-200 p-8 rounded-md justify-center">
                    <FaFile className="text-slate-600 h-16 w-16" />
                  </div>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="flex flex-row gap-2 bg-white p-2 rounded-md">
            <NoDataScreen text={"No hay media subida"} />
          </div>
        )}
      </div>
    </div>
  )
}

export default ChecklistServicio
